export default "__VITE_ASSET__Dlrfl8aZ__"